import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "../../lib/api";

const LABEL = { valid: "Valid ticket", cancelled: "Cancelled registration", invalid: "Invalid ticket" };

export default function TicketCheck() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/public/ticket/${encodeURIComponent(token)}`).then((r) => setD(r.data)).catch(() => setD({ status: "invalid" })); }, [token]);
  if (!d) return <div className="container-site py-24" data-testid="ticket-loading">Checking ticket…</div>;
  const ok = d.status === "valid";
  return (
    <div className="container-site py-20" data-testid="ticket-check-page">
      <div className={`mx-auto max-w-md rounded-lg border-2 p-8 text-center ${ok ? "border-green-700 bg-green-50" : "border-burgundy bg-[#FEF3F3]"}`}>
        {ok ? <CheckCircle2 size={56} className="mx-auto text-green-700" aria-hidden="true" /> : <XCircle size={56} className="mx-auto text-burgundy" aria-hidden="true" />}
        <h1 className="mt-4 text-3xl text-navy" data-testid="ticket-status">{LABEL[d.status] || LABEL.invalid}</h1>
        {d.name && <dl className="mt-6 space-y-1 text-left text-sm" data-testid="ticket-info">
          <div className="flex justify-between"><dt className="text-slate-600">Name</dt><dd className="font-semibold text-navy">{d.name}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-600">Category</dt><dd>{d.category}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-600">Attendance</dt><dd>{d.attendance}</dd></div>
        </dl>}
      </div>
    </div>
  );
}
